

export default class CertificadoResponse {
    constructor(
        public header?: header,
        public data?: string,
        public msjPagina?: string
    ) {}
} 

class header {
    constructor(
        public code?:  number,
        public lambdaVersion?: string,
        public lambdaAlias?: string,
        public lambdaName?: string,
        public message?: string,
        public detail?: string,
        public success?: boolean,
    ) {}
}
export { header ,CertificadoResponse}